import React from "react";
import classNames from "classnames";
import { KatButton, KatIcon } from "@amzn/katal-react";
import { useTranslation } from "react-i18next";

import { useDocumentComplianceHelper } from "./DocumentComplianceHelperContext";
import styles from "./styles.module.scss";
import publishMetric, { MetricAction } from "src/metrics";

const DocumentComplianceHelperButton: React.FC = () => {
  const { t } = useTranslation();
  const { setVisible } = useDocumentComplianceHelper();

  const handleOpenHelper = () => {
    publishMetric(MetricAction.COMPLIANCE_HELPER_MODAL_OPENING);
    setVisible(true);
  };

  return (
    <div className={classNames(styles.helper_button)}>
      <KatButton
        variant="tertiary"
        size="base"
        onClick={() => handleOpenHelper()}
      >
        <KatIcon name="info-circle" size="small" />
        {"   "} {t("aic_doc_page_inbound_document_compliance_helper_title")}
      </KatButton>
    </div>
  );
};

export default DocumentComplianceHelperButton;
